import React, { Component, Fragment } from 'react';
import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';
import _ from 'lodash';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

import CardComponent from '../components/Card';
import ColSettings from '../components/ColSettings';
import { 
    SelectInput, 
    SwitchInput, 
    TextInput, 
    SortableList, 
    CardElement, 
    AddButton, 
    CopyButton,
    DeleteButton,
    Modal, 
    GridInput,
    StatusChip,
    EmptyState
} from '../../_Components';
// import PhonesList from '../components/PhonesList';
import PhonesInput from '../components/PhonesField';
import AddAction from '../components/AddAction';



const styles = {
    row: {
        display: 'flex',
        borderBottom: '1px solid',
        marginTop: 16
    },
    taskRow: {
        display: 'flex',
        borderBottom: '1px solid',
        marginTop: 8,
        marginBottom: 16,
        paddingBottom: 16
    },
    actionTaskRow: {
        display: 'flex',
        marginTop: 8,
        // paddingBottom: 20
    },
    actionTaskButton: {
        marginBottom: 0
    },
    resultElement: {
        display: 'inline-flex',
        marginRight: '2em',
        width: '25%'
    },
    radio: {
        paddingRight: 30,
        flex: 'auto'
    },
    buttonGroup: {
        marginTop: 11,
        flex: '0 0 auto',
        alignSelf: 'flex-start'
    }
};

const itemsFields = [
    {
        value: 'resultLabel'
    },
    {
        value: 'taskLabel'
    },
    {
        value:'subTaskLabel'
    }
];

const ListForm = ({list}) => (
    <Field
        name="list"
        required={true}
        component={GridInput}
        label={``}
        avalible={list}
    />
)

const PhonePanel = ({list}) => (
    <Field 
        name={`phones`}
        component={PhonesInput}
        list={list}
    />
)

const actionLabels = (action, result, task) => {
    const resultOpt = result && result.options && result.options.find((el) => el.value === action.result);
    const taskOpt = task && task.options && task.options.find((el) => el.value === action.task);
    const subOpt = action.sub_task && taskOpt && taskOpt.sub
        ? taskOpt.sub.find((e) => e.value === action.sub_task)
        : null;
    return {
        resultLabel: resultOpt ? resultOpt.label : '-',
        taskLabel: taskOpt ? taskOpt.label : '-',
        subTaskLabel: subOpt ? subOpt.label : '-',
    };
};

const processingId = (value) => {
    if (!value) return '';
    if (typeof value === 'object') return String(value._id || value.id || '');
    return String(value);
};

const processingOptions = (list) => (
    (list || [])
        .map((item) => {
            const id = processingId(item._id || item.id);
            if (!id) return null;
            const kind = item.type === 'email' ? 'E-mail' : item.type === 'bitrix' ? 'Bitrix' : '';
            return {
                id,
                name: kind ? `${item.name || 'Без названия'} · ${kind}` : (item.name || 'Без названия'),
            };
        })
        .filter(Boolean)
);

const ProcessingPick = ({ input, meta, label, list }) => {
    const options = [{ id: '__none__', name: 'Не запускать' }].concat(processingOptions(list));
    const current = processingId(input && input.value) || '__none__';
    return (
        <SelectInput
            label={label}
            options={options}
            meta={meta}
            input={{
                ...input,
                value: current,
                onChange: (event) => {
                    const next = event && event.target ? event.target.value : event;
                    input.onChange(!next || next === '__none__' ? null : next);
                },
            }}
        />
    );
};


class CardActions extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.state = {
            activeNode: null,
            selectedIndex: 0,
            activePath: null,
            activeOptions: null,
            activePathOptions: null,
            activeNodekey: 0,
            optionsData: [],
            openEdit: false,
            openOptionEdit: false,
            openSubsEdit: false,
            editCombobox: null,
            editOption: null,
            editOptionKey: null,
            expanded: null,
            changedResult: '',
            changedTask: '',
            subs: [],
            openEmails: false,
            openTelegram: false,
            addAction: false,
            width: 0,
            query: ''
        };


        this.setActiveNode = this.setActiveNode.bind(this);
        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.selectCol = this.selectCol.bind(this);
        this.updateItems = this.updateItems.bind(this);
        this.onСhangeResult = this.onСhangeResult.bind(this);
        this.onСhangeTask = this.onСhangeTask.bind(this);
        this.closeEmailsList = this.closeEmailsList.bind(this);
        this.saveEmails = this.saveEmails.bind(this);
        this.addActionDialog = this.addActionDialog.bind(this);
        this.saveAction = this.saveAction.bind(this);
        this.closeTelegramList = this.closeTelegramList.bind(this);
        this.saveTelegram = this.saveTelegram.bind(this);
        this.closePhonesList = this.closePhonesList.bind(this);
        this.savePhones = this.savePhones.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.copyAction = this.copyAction.bind(this);
        this.findCombobox = this.findCombobox.bind(this);
        this.openEmailsList = this.openEmailsList.bind(this);
        this.openTelegramList = this.openTelegramList.bind(this);
        this.openPhonesList = this.openPhonesList.bind(this);
    }

    onСhangeResult(state,{ props: { value } }) {
        this.setState({ changedResult: value})
    }

    onСhangeTask(state,{ props: { value } }){
        const { task } = this.props;
        let subs = task.options.find( t => t.value===value) ? task.options.find( t => t.value===value).sub : [];
        this.setState({ changedTask: value, subs})
    }

    onDragStart(layout,element){
        this.selectCol(element.i);
    }

    setActiveNode = (index) => {
        const { options } = this.props.formValues.actions[index];
        this.setState({ optionsData: options, activeNodekey: index, expanded: null, selectedIndex: 0 })
    }
    selectCol(index) {
        const { formValues: { actions } } = this.props;
        const { activeNodekey } = this.state
        const i = _.findIndex(actions[activeNodekey].cols, {field: index});
        this.setState({selectedIndex: i});
    }

    addItem(item) {
        const { activeNodekey } = this.state;
        const { formValues: { actions }, change } = this.props;
        const cols = [...(actions[activeNodekey].cols || []), {
            ...item,
            col : item.x,
            row : item.y,
            sizeX : item.w,
            sizeY: item.h,
        }];
        change(`actions[${activeNodekey}].cols`, cols);
        this.setState({ selectedIndex: cols.length-1 });
    }

    updateItems(items) {
        const { activeNodekey } = this.state;
        const { formValues: { actions }, change } = this.props;
        const { cols } = actions[activeNodekey]
        const newItems = items.map( (item,i) => {
            const el = cols[`${i}`];
            return {
                ...el,
                col : item.x,
                row : item.y,
                sizeX : item.w,
                sizeY: item.h,
            }
        });
        change(`actions[${activeNodekey}].cols`, newItems);
    }


    removeItem(i) {
        const { activeNodekey } = this.state;
        const { formValues: { actions }, change } = this.props;
        const cols = (actions[activeNodekey].cols || []).filter((_, index) => index !== i);
        change(`actions[${activeNodekey}].cols`, cols);
    }

    openEmailsList() {
        this.setState({ openEmails: true });
    }

    closeEmailsList() {
        this.setState({ openEmails: false });
    }
   
    saveEmails(form) {
        const { list } = form;
        const { activeNodekey } = this.state;
        const { change } = this.props;
        this.setState({ openEmails: false },
           () => change(`actions[${activeNodekey}].settings.emails`, list)
        );
    }

    openTelegramList() {
        this.setState({ openTelegram: true });
    }

    closeTelegramList() {
        this.setState({ openTelegram: false });
    }

    saveTelegram(form) {
        const { list } = form;
        const { activeNodekey } = this.state;
        const { change } = this.props;
        this.setState({ openTelegram: false },
           () => change(`actions[${activeNodekey}].settings.telegramChats`, list)
        );
    }

    openPhonesList() {
        this.setState({ openPhones: true });
    }

    closePhonesList() {
        this.setState({ openPhones: false });
    }
   
    savePhones({phones}) {
        const { activeNodekey } = this.state;
        const { change } = this.props;
        this.setState({ openPhones: false },
           () => change(`actions[${activeNodekey}].settings.transfer_phones`, phones)
        );
    }

    deleteAction(index) {
        const { formValues: { actions }, change } = this.props;
        const next = (actions || []).filter((_, i) => i !== index);
        const nextKey = next.length === 0 ? 0 : Math.min(index, next.length - 1);
        this.setState({ activeNodekey: nextKey, selectedIndex: 0 },
            () => change('actions', next)
        );
    }

    copyAction(action) {
        this.setState({ copyFields: _.cloneDeep(action), addAction: true});
    }

    addActionDialog() {
        this.setState((state) => (
            state.addAction
                ? { addAction: false, copyFields: null }
                : { addAction: true, copyFields: null }
        ));
    }

    saveAction(values){
        const { formValues, change, result, task } = this.props;
        const actions = (formValues && formValues.actions) || [];
        const nextAction = {
            ..._.cloneDeep(values),
            ...actionLabels(values, result, task),
        };
        const next = actions.concat(nextAction);
        this.setState({ addAction: false, copyFields: null, activeNodekey: next.length - 1, selectedIndex: 0 },
           () => change('actions', next)
        );
    }

    findCombobox(item) {
        const options = [{ id: undefined, name: '-' }];
        if (!item) return options;
        const fields = this.props.fields || [];
        const comboboxes = this.props.comboboxes || [];
        const field = fields.find((el) => el.id === item.field || el.value === item.field);
        if (!field || !field.combobox) return options;
        const combobox = comboboxes.find((el) => el._id === field.combobox);
        if (combobox && Array.isArray(combobox.options)) {
            combobox.options.forEach((el) => options.push({ id: el.value, name: el.label }));
        }
        return options;
    }

    updateLayoutElements=()=>{
        if (!this.ref.current) return;
        const next = this.ref.current.clientWidth;
        if (next > 0 && this.state.width !== next) {
            this.setState({ width: next });
        }
    }
    componentDidMount(){
        window.addEventListener('resize', this.updateLayoutElements);
        this.updateLayoutElements();
        if (typeof ResizeObserver !== 'undefined' && this.ref.current) {
            this.resizeObserver = new ResizeObserver(() => this.updateLayoutElements());
            this.resizeObserver.observe(this.ref.current);
        }
    }
    componentDidUpdate(){
        this.updateLayoutElements();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateLayoutElements);
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }


    render() {
        const { activeNodekey, selectedIndex, openEmails, openTelegram, openPhones, addAction, copyFields, query } = this.state;
        const { formValues, result, fields, task, project } = this.props;
        const actions = (formValues && formValues.actions) || [];
        const action = actions[activeNodekey];
        const q = (query || '').trim().toLowerCase();
        const visibleActions = actions
            .map((item, index) => ({ ...item, ...actionLabels(item, result, task), __index: index }))
            .filter((item) => {
                if (!q) return true;
                return [item.resultLabel, item.taskLabel, item.subTaskLabel, item.result, item.task, item.sub_task]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase()
                    .indexOf(q) >= 0;
            });
        const selectedCol = action && action.cols && action.cols[selectedIndex];
        const taskOptions = (task && task.options) || [];
        const resultOptions = (result && result.options) || [];
        const currentTask = action && taskOptions.find((item) => item.value === action.task);
        const subOptions = currentTask && currentTask.sub ? currentTask.sub : [];

        return(
            <Fragment>
                {addAction&&<AddAction open={addAction} close={this.addActionDialog} save={this.saveAction}  copyFields={copyFields} results={resultOptions} tasks={taskOptions} />}
                <div className="pc-fill">
                <div className="pc-split pc-split--act">
                    <CardElement
                        fill
                        title="Действия"
                        subheader={<StatusChip tone="mono">{q ? `${visibleActions.length} из ${actions.length}` : actions.length}</StatusChip>}
                        action={<AddButton handleAddClick={this.addActionDialog} label={'Новое'} variant="contained" />}
                        content={
                            <div className="pc-panel-body">
                                <div className="pc-toolbar">
                                    <TextField
                                        className="pc-search"
                                        size="small"
                                        placeholder="Результат, тема или подтема"
                                        value={query}
                                        onChange={(event) => this.setState({ query: event.target.value })}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon sx={{ fontSize: 16, color: 'var(--muted-2)' }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{ maxWidth: '100%', flex: 1 }}
                                    />
                                </div>
                                <div className="pc-tblwrap">
                                    <SortableList
                                        items={visibleActions}
                                        itemsFields={itemsFields}
                                        useDragHandle={true}
                                        setActiveNode={this.setActiveNode}
                                        activeNodekey={activeNodekey}
                                        sortable={false}
                                    />
                                    {actions.length === 0 && (
                                        <EmptyState
                                            title="Нет действий"
                                            description="Добавьте действие для темы и результата звонка."
                                        />
                                    )}
                                    {actions.length > 0 && visibleActions.length === 0 && (
                                        <EmptyState
                                            title="Ничего не найдено"
                                            description="Измените запрос или сбросьте поиск."
                                        />
                                    )}
                                </div>
                            </div>
                        }
                    />
                    <CardElement
                        fill
                        title={action ? (action.subTaskLabel || action.taskLabel || 'Действие') : 'Действие'}
                        action={action ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <CopyButton label="Дублировать" onClick={() => this.copyAction(action)} />
                                <DeleteButton label="Удалить" onClick={() => this.deleteAction(activeNodekey)} />
                            </div>
                        ) : null}
                        content={action ? (
                            <div className="pc-panel-body">
                                <div className="pc-tblwrap">
                                    <div className="pc-sect">
                                        <div className="pc-sect__t">Когда срабатывает</div>
                                        <div className="pc-fgrid pc-fgrid--3">
                                            <Field
                                                name={`actions[${activeNodekey}].result`}
                                                label="Результат"
                                                required={true}
                                                component={SelectInput}
                                                options={resultOptions.map((item) => ({ id: item.value, name: item.label }))}
                                            />
                                            <Field
                                                name={`actions[${activeNodekey}].task`}
                                                label="Тема"
                                                required={true}
                                                component={SelectInput}
                                                options={taskOptions.map((item) => ({ id: item.value, name: item.label }))}
                                            />
                                            {subOptions.length > 0 && (
                                                <Field
                                                    name={`actions[${activeNodekey}].sub_task`}
                                                    label="Подтема"
                                                    component={SelectInput}
                                                    options={subOptions.map((item) => ({ id: item.value, name: item.label }))}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="pc-sect">
                                        <div className="pc-sect__t">Дополнительные поля</div>
                                        <div ref={this.ref} className="pc-formgrid-wrap">
                                            <CardComponent
                                                width={this.state.width || 480}
                                                maxRows={3}
                                                rowHeight={52}
                                                margin={[8, 8]}
                                                readOnly={true}
                                                key={activeNodekey}
                                                actions={true}
                                                elements={action.cols || []}
                                                fields={fields || []}
                                                selectedIndex={selectedIndex}
                                                activeNodekey={activeNodekey}
                                                addItem={this.addItem}
                                                selectCol={this.selectCol}
                                                removeEvent={this.removeItem}
                                                updateItems={this.updateItems}
                                                onDragStart={this.onDragStart}
                                            />
                                        </div>
                                    </div>
                                    <div className="pc-sect">
                                        <div className="pc-sect__t">Что происходит дальше</div>
                                        <div className="pc-togrow">
                                            <div className="pc-togrow__txt">
                                                <b>Перевод звонка</b>
                                                <span>Оператор соединяет клиента с сотрудником отдела.</span>
                                            </div>
                                            <Field name={`actions[${activeNodekey}].settings.transfer`} component={SwitchInput} />
                                        </div>
                                        {action.settings && action.settings.transfer && (
                                            <div className="pc-fgrid" style={{ marginBottom: 8 }}>
                                                <Field
                                                    name={`actions[${activeNodekey}].settings.transfer_prefix`}
                                                    label="Префикс набора"
                                                    component={TextInput}
                                                    mono={true}
                                                />
                                                <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 2 }}>
                                                    <AddButton
                                                        label={(action.settings.transfer_phones || []).length > 0
                                                            ? `Выбрано ${action.settings.transfer_phones.length}`
                                                            : 'Номер'}
                                                        handleAddClick={this.openPhonesList}
                                                    />
                                                </div>
                                                {openPhones && (
                                                    <Modal
                                                        width={800}
                                                        title="Добавить телефон"
                                                        open={openPhones}
                                                        handleSaveClick={this.savePhones}
                                                        handleCloseClick={this.closePhonesList}
                                                        initial={{ phones: action.settings.transfer_phones || [] }}
                                                        fields={<PhonePanel list={formValues.transfer && formValues.transfer.departments} />}
                                                    />
                                                )}
                                                <Field
                                                    name={`actions[${activeNodekey}].settings.transfer_success`}
                                                    label="Обработка, если перевод состоялся"
                                                    component={ProcessingPick}
                                                    list={formValues.processing || []}
                                                />
                                                <Field
                                                    name={`actions[${activeNodekey}].settings.transfer_fail`}
                                                    label="Обработка, если перевод не состоялся"
                                                    component={ProcessingPick}
                                                    list={formValues.processing || []}
                                                />
                                            </div>
                                        )}
                                        {action.settings && action.settings.transfer && !(formValues.processing || []).length && (
                                            <div className="pc-field__hint" style={{ margin: '-4px 0 10px' }}>
                                                Сначала создайте рецепт во вкладке «Обработка» — тогда его можно выбрать здесь.
                                            </div>
                                        )}
                                        <div className="pc-togrow">
                                            <div className="pc-togrow__txt">
                                                <b>Отправить e-mail</b>
                                                <span>Письмо по шаблону на адреса проекта.</span>
                                            </div>
                                            <Field name={`actions[${activeNodekey}].settings.email`} component={SwitchInput} />
                                        </div>
                                        {action.settings && action.settings.email && (
                                            <div className="pc-fgrid" style={{ marginBottom: 8 }}>
                                                <Field
                                                    name={`actions[${activeNodekey}].settings.template`}
                                                    label="Шаблон письма"
                                                    component={SelectInput}
                                                    options={(formValues.template || []).filter((item) => item.type === 'email')}
                                                />
                                                <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 2 }}>
                                                    <AddButton
                                                        label={(action.settings.emails || []).length > 0
                                                            ? `Выбрано ${action.settings.emails.length}`
                                                            : 'Добавить E-mail'}
                                                        handleAddClick={this.openEmailsList}
                                                    />
                                                </div>
                                                {openEmails && (
                                                    <Modal
                                                        width={640}
                                                        title="Добавить E-mail"
                                                        open={openEmails}
                                                        handleSaveClick={this.saveEmails}
                                                        handleCloseClick={this.closeEmailsList}
                                                        initial={{ list: action.settings.emails }}
                                                        fields={<ListForm list={project.settings.list.email} />}
                                                    />
                                                )}
                                            </div>
                                        )}
                                        <div className="pc-togrow">
                                            <div className="pc-togrow__txt">
                                                <b>Отправить в Telegram</b>
                                                <span>Сообщение в чаты, указанные в проекте.</span>
                                            </div>
                                            <Field name={`actions[${activeNodekey}].settings.telegram`} component={SwitchInput} />
                                        </div>
                                        {action.settings && action.settings.telegram && (
                                            <div className="pc-fgrid" style={{ marginBottom: 8 }}>
                                                <Field
                                                    name={`actions[${activeNodekey}].settings.templateTelegram`}
                                                    label="Шаблон сообщения"
                                                    component={SelectInput}
                                                    options={(formValues.template || []).filter((item) => item.type === 'telegram')}
                                                />
                                                <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 2 }}>
                                                    <AddButton
                                                        label={(action.settings.telegramChats || []).length > 0
                                                            ? `Выбрано ${action.settings.telegramChats.length}`
                                                            : 'Добавить чат'}
                                                        handleAddClick={this.openTelegramList}
                                                    />
                                                </div>
                                                {openTelegram && (
                                                    <Modal
                                                        width={640}
                                                        title="Добавить Telegram чат"
                                                        open={openTelegram}
                                                        handleSaveClick={this.saveTelegram}
                                                        handleCloseClick={this.closeTelegramList}
                                                        initial={{ list: action.settings.telegramChats }}
                                                        fields={<ListForm list={project.settings.list.telegram} />}
                                                    />
                                                )}
                                            </div>
                                        )}
                                        <div className="pc-togrow">
                                            <div className="pc-togrow__txt">
                                                <b>Создать сущность в CRM</b>
                                                <span>Переопределяет настройку карточки для этого действия.</span>
                                            </div>
                                            <Field name={`actions[${activeNodekey}].settings.create`} component={SwitchInput} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <EmptyState
                                title="Действие не выбрано"
                                description="Выберите действие слева или создайте новое."
                            />
                        )}
                    />
                    <CardElement
                        fill
                        title="Свойства поля"
                        content={(
                            <div className="pc-panel-body">
                                <div className="pc-tblwrap">
                                    {action && selectedCol ? (
                                        <ColSettings
                                            items={action.cols}
                                            path={`actions[${activeNodekey}].cols`}
                                            item={selectedCol}
                                            selectedIndex={selectedIndex}
                                            fields={fields || []}
                                            combobox={this.findCombobox(selectedCol)}
                                        />
                                    ) : (
                                        <EmptyState
                                            title="Поле не выбрано"
                                            description="Кликните поле в форме действия."
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    />
                </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, props) => {
    const formValues = getFormValues('card')(state);
    const { fetch } = state;
    return { 
        formValues,
        isLoading: !!fetch.loading
    }
};

export default  compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
        destroyOnUnmount: false, // <------ preserve form data
        forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    }),
    withStyles(styles),
)(CardActions);